import { FETCH_CLINICS_BY_PREFECTURE } from 'containers/ClinicsPage/constants';
export const fetchClinicsByPrefecture = (payload, params) => ({
  type: FETCH_CLINICS_BY_PREFECTURE,
  payload,
  params,
});
